module.exports = __webpack_public_path__ + "img/logo-vcard-m.45852ad.png";